import { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import media from '@activebrands/core-web/config/media';
import { styled } from '@activebrands/core-web/libs/styletron';
import ThemeButton from 'components/buttons/ThemeButton';
import { Link } from 'gatsby';

const SubCategories = styled('div', {
    display: 'flex',
    gap: '8px',
    whiteSpace: 'nowrap',
    overflowX: 'auto',
    padding: '0 0 1px 1px',

    [media.min['desktop.sm']]: {
        flexWrap: 'wrap',
        whiteSpace: 'initial',
        overflowX: 'initial',
    },

    '::-webkit-scrollbar': {
        height: '2px',
        borderRadius: '2px',
    },
    '::-webkit-scrollbar-track ': {
        borderRadius: '2px',
    },
    '::-webkit-scrollbar-thumb': {
        borderRadius: '2px',
    },
});

const SubCategoryButtons = ({
    $style = {},
    buttonSize = 'sm',
    buttonStyle = {},
    fontStyling = {},
    items = [],
    theme = 'default',
    withScrollbar = false,
    ...rest
}) => {
    const ref = useRef(null);

    useEffect(() => {
        if (ref.current) {
            const activeLink = ref.current.querySelector('[aria-current="page"]');

            if (activeLink && activeLink.offsetLeft + activeLink.offsetWidth > ref.current.offsetWidth) {
                ref.current.scrollLeft = activeLink.offsetLeft;
            }
        }
    }, []);

    return (
        <SubCategories
            $style={{
                paddingBottom: withScrollbar ? '16px' : 0,
                ...$style,
            }}
            as="nav"
            ref={ref}
            scrolldirection="horizontal"
            {...rest}
        >
            {items.map(item => (
                <ThemeButton
                    $style={{ ...buttonStyle, ...fontStyling }}
                    active={item.isActive}
                    as={Link}
                    key={item.id}
                    theme={theme}
                    size={buttonSize}
                    to={item.to}
                    onClick={item.onClick}
                >
                    {item.label}
                </ThemeButton>
            ))}
        </SubCategories>
    );
};

SubCategoryButtons.propTypes = {
    $style: PropTypes.object,
    buttonSize: PropTypes.string,
    buttonStyle: PropTypes.object,
    fontStyling: PropTypes.object,
    items: PropTypes.arrayOf(
        PropTypes.shape({
            iconSrc: PropTypes.string,
            id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
            isActive: PropTypes.bool,
            label: PropTypes.string,
            to: PropTypes.string,
            onClick: PropTypes.func,
        })
    ).isRequired,
    theme: PropTypes.string,
    useIcons: PropTypes.bool,
    withScrollbar: PropTypes.bool,
};

export default SubCategoryButtons;
